import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import LeadInActivitiesEmbed from '../components/Exercise/LeadInActivitiesEmbed';

export default Node.create({
  name: 'leadInActivitiesExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      activities: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('activities');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing LeadInActivities from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.activities) {
            return {
              activities: JSON.stringify(attributes.activities)
            };
          }
          return {};
        }
      },
      title: {
        default: 'Lead-in Activities',
        parseHTML: element => element.getAttribute('title') || 'Lead-in Activities',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      text: {
        default: '',
        parseHTML: element => element.getAttribute('text') || '',
        renderHTML: attributes => {
          if (attributes.text) {
            return {
              text: attributes.text
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="lead-in-activities-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'lead-in-activities-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(LeadInActivitiesEmbed);
  },
  
  addCommands() {
    return {
      insertLeadInActivitiesExercise:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 